module.exports = __webpack_public_path__ + "img/file.932306a9.svg";